var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { AdminMessageUIRequest, MessageUIRequestType } from "@/share/Message";
import { DateLib } from "@@/Datelib";
import { action, makeObservable, observable } from "mobx";
export class AdminRepliesUIStore {
    constructor() {
        this.open = false;
        this.mainmessageid = "";
        this.loadingReplies = false;
        this.loadingMore = false;
        this.repliesById = new Map();
        this.lastCount = -1;
        this.edittingMessageId = "";
        this.editingHtml = "";
        this.savingedit = false;
        this.letrid = "";
        this.lastReplyTime = 0;
        this.scrollToId = '';
        this.zIndex = 100;
        this.replyLoadCount = 10000;
        this.activeuserid = "";
        makeObservable(this);
        APPEvent.addSubscriberForActiveLetr(l => this.letrid = l);
        APPEvent.addSubscriberForAdminMessageResponse((res) => {
            if (res.type === MessageUIRequestType.FetchReplies) {
                res.msg.forEach((m) => this.addReply(m));
                if (res.msg.length < this.replyLoadCount) {
                    this.setLastCount(0);
                }
                else {
                }
            }
            this.setLoading(false);
            this.setLoadingMore(false);
        });
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.reset();
            this.activeuserid = useird;
        });
    }
    setActiveMessageId(id) {
        this.mainmessageid = id;
    }
    setZIndex(zindex) {
        this.zIndex = zindex;
    }
    setEditMessageId(id) {
        if (this.savingedit) {
            return;
        }
        this.edittingMessageId = id;
        const msg = this.repliesById.get(id);
        if (msg !== undefined) {
            this.setEditText(msg.text);
        }
        else {
            this.setEditText("");
        }
    }
    setEditText(text) {
        this.editingHtml = text;
    }
    setScrollToId(id) {
        this.scrollToId = id;
    }
    setSavingEdit(save) {
        this.savingedit = save;
    }
    removeMessage(msg) {
        this.repliesById.delete(msg._id);
    }
    setLastCount(count) {
        this.lastCount = count;
    }
    getMessageTime(msg) {
        return DateLib.getTodayTimeOrDate(msg.createdAt);
    }
    addReply(m) {
        this.repliesById.set(m._id, m);
        if (m.createdAt > this.lastReplyTime) {
            this.lastReplyTime = m.createdAt;
        }
    }
    setMainMessage(mainMessage) {
        this.mainMessage = mainMessage;
        this.reset();
    }
    setActiveLetrid(letrid) {
        this.letrid = letrid;
    }
    loadReplies() {
        if (this.letrid === ""
            || this.loadingMore
            || this.loadingReplies || this.mainMessage === undefined
            || this.lastCount === 0) {
            return;
        }
        this.setLoading(true);
        const req = new AdminMessageUIRequest();
        req.letrid = this.letrid;
        req.count = this.replyLoadCount;
        req.parentid = this.mainMessage._id;
        req.type = MessageUIRequestType.FetchReplies;
        req.sortAsc = true;
        req.time = 0;
        req.userid = req.userid;
        this.requestMessages(req);
    }
    getReplies() {
        return Array.from(this.repliesById.values()).sort(this.sortByTime);
    }
    sortByTime(t1, t2) {
        return t1.createdAt - t2.createdAt;
    }
    requestMessages(req) {
        Apphandler.sendMessage("adminmessages", req);
    }
    setLoading(loading) {
        this.loadingReplies = loading;
    }
    setLoadingMore(loading) {
        this.loadingMore = loading;
    }
    setOpen(open) {
        this.open = open;
    }
    reset() {
        this.repliesById = new Map();
        this.lastReplyTime = 0;
        this.scrollToMessage = undefined;
        this.zIndex = 0;
        this.setActiveMessageId("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "mainMessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "mainmessageid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "loadingReplies", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "loadingMore", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminRepliesUIStore.prototype, "repliesById", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "lastCount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "edittingMessageId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "editingHtml", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "savingedit", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminRepliesUIStore.prototype, "scrollToId", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], AdminRepliesUIStore.prototype, "zIndex", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setActiveMessageId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setEditMessageId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setEditText", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setScrollToId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setSavingEdit", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "removeMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setLastCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "addReply", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setMainMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setActiveLetrid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setLoadingMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminRepliesUIStore.prototype, "reset", null);
